import React, { useEffect, useState } from "react";
import { message, Tag } from "antd";
import api from "../api/api";
import styled from "styled-components";

const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1e1e1e;
`;

const LanguageBar = () => {
  const [data, setData] = useState();
//   const [loading, setLoading] = useState(true);
  useEffect(() => {
    getPanelInfo();
    // eslint-disable-next-line
  }, []);
  const getPanelInfo = () => {
    api
      .getPanelInfo()
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };
  return (
    <Tag
      color="default"
      style={{
        padding: "6px 12px",
        border: 0,
        borderRadius: 10,
        display: "flex",
        alignItems: "center",
        gap: "8px",
        backgroundColor: "#F0F6FE",
        marginBottom: "16px",
      }}
    >
      <Text>Languages:</Text>
      <Text style={{ color: "#1859FF" }}>
        {data?.storeLanguages?.map((lang) => lang.language).join(", ") ||
          "English"}
      </Text>
    </Tag>
  );
};

export default LanguageBar;
